import { render } from "./industry-chart.vue?vue&type=template&id=2ec60ed0"
import script from "./industry-chart.vue?vue&type=script&lang=ts"
export * from "./industry-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script